import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import DemoPage from "./screens/DemoPage";

function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={DemoPage} />
      </Switch>
    </Router>
  );
}

export default Routes;
